import React from 'react';

import AuthCode from 'react-auth-code-input';
import {Box, Grid, Typography} from '@material-ui/core';

import {EfeOtpTypes} from 'commons/types/Types';
import {EfeButtonPrimary} from 'components/buttons';

type Props = {
    title?: string;
    length: number;
    type?: EfeOtpTypes;
    isPassword: boolean;
    placeholder?: string;
    buttonPlaceholder?: string;
    handleClick: (values: string) => void;
};

function EfeOtp(props: Props) {
    const {title, length, type, isPassword, placeholder, buttonPlaceholder, handleClick} = props;

    const [code, setCode] = React.useState<string>('');

    function onChange(values: string) {
        setCode(values);
    }

    return (
        <Grid container direction='row' justifyContent='flex-start'>
            <Grid item xs={12}>
                <Box display='flex' flexDirection='row' justifyContent='center' m={2}>
                    {title && (
                        <Typography variant='body1' display='block' gutterBottom color='primary'>
                            {title}
                        </Typography>
                    )}
                </Box>
                <Box display='flex' flexDirection='row' justifyContent='center' m={2}>
                    <AuthCode
                        length={length}
                        isPassword={isPassword}
                        placeholder={placeholder}
                        allowedCharacters={type}
                        onChange={onChange}
                        inputClassName='opt-class'
                    />
                </Box>

                <Box display='flex' flexDirection='row' justifyContent='center' m={2}>
                    <Grid item xs={4}>
                        <Box m={2}>
                            <EfeButtonPrimary
                                fullWidth
                                onClick={() => handleClick(code)}
                                disabled={!code || code.length != length}>
                                {buttonPlaceholder ? buttonPlaceholder : 'Aceptar'}
                            </EfeButtonPrimary>
                        </Box>
                    </Grid>
                </Box>
            </Grid>
        </Grid>
    );
}

export default EfeOtp;
